var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlimitedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18 5.01597C18 2.78471 15.3268 1.70689 13.8176 3.21614L8.45018 8.58355C5.29769 11.736 0 9.37741 0 5.01597C0 0.654523 5.29769 -1.70411 8.45018 1.44838L8.6339 1.6321C9.12205 2.12025 9.12205 2.91171 8.6339 3.39986C8.14574 3.88802 7.35429 3.88802 6.86613 3.39986L6.68241 3.21614C5.17316 1.70689 2.5 2.78471 2.5 5.01597C2.5 7.24722 5.17316 8.32504 6.68241 6.81579L12.0498 1.44837C15.2023 -1.70412 20.5 0.654527 20.5 5.01597C20.5 9.37741 15.2023 11.736 12.0498 8.58355L11.8661 8.39985C11.378 7.91169 11.378 7.12024 11.8661 6.63208C12.3543 6.14392 13.1457 6.14392 13.6339 6.63208L13.8176 6.81578C15.3268 8.32504 18 7.24721 18 5.01597Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedIcon);
export default __webpack_public_path__ + "static/media/unlimited-icon.c168cbb6c855a24ca21bb71623b7c1db.svg";
export { ForwardRef as ReactComponent };